import { Text } from '../../../text/text.component';
import { styles } from './date-navigator.styles';
import { DateNavigatorContentChildren, DateNavigatorFormattedDate } from './date-navigator.types';

export const DefaultButtonContent = ({
  renderFn,
  formattedDateObj,
  children, // children is the default content we want to display for each variant
  value,
}: {
  renderFn?: DateNavigatorContentChildren;
  formattedDateObj: DateNavigatorFormattedDate;
  children: React.ReactNode;
  value: string;
}) => {
  const renderedElement = renderFn ? (typeof renderFn === 'function' ? renderFn(formattedDateObj) : renderFn) : null;

  return (
    <>
      {renderedElement ||
        (formattedDateObj.isValid ? (
          <div className={styles.dateText}>{children}</div>
        ) : (
          <Text weight='regular'>{value}</Text>
        ))}
    </>
  );
};
